import React, { useState } from "react";
import { MapPin } from "lucide-react";
import AvatarLayered from "../AvatarLayered";
import { wrestlerAvatar } from "../../lib/api";
import { TourClaimPops } from "./TourClaimPops";

function BenchCard({ w, selected, pops, onSelect, onDragStart }) {
  return (
    <div draggable onDragStart={(e) => onDragStart(e, w.wrestler_id)} onClick={(e) => { e.stopPropagation(); onSelect(w.wrestler_id); }}
         data-testid={`tour-bench-${w.wrestler_id}`}
         className={`relative w-[56px] sm:w-auto sm:flex-1 sm:min-w-0 sm:max-w-[76px] rounded-lg p-1 bg-[#0A051A] border-2 cursor-grab active:cursor-grabbing transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_0_14px_#00F0FF66] ${selected ? "border-[#FFE600] shadow-[0_0_14px_#FFE60099]" : "border-[#00F0FF]/50"}`}>
      <TourClaimPops gains={pops} className="top-1" />
      <AvatarLayered fgSrc={wrestlerAvatar(w)} promo={w.owner_promotion} alt={w.name} className="w-full aspect-square rounded-md" />
      <div className="mt-0.5 font-heading text-[9px] uppercase truncate text-center leading-tight">{w.name}</div>
      <div className="font-mono text-[8px] text-[#A89BCC] text-center leading-tight">{w.gain_active.toFixed(2)}/s</div>
    </div>
  );
}

function PlaneButtons({ planes, onOpenPlane }) {
  if (!planes?.length) return null;
  return (
    <div className="absolute top-2 right-3 flex items-center gap-1" data-testid="tour-plane-buttons">
      {planes.map((p) => (
        <button key={p.id} data-testid={`tour-plane-btn-${p.id}`} onClick={() => onOpenPlane(p.id)} title={`Airplane ${p.n}${p.enabled ? "" : " (off)"}`}
                className="w-7 h-7 rounded-md border border-[#00F0FF]/40 bg-[#0A051A] hover:border-[#00F0FF] hover:scale-110 transition-transform flex items-center justify-center">
          <img src="/tour/World Tour Icon Plane.webp" alt="" className="w-5 h-5" style={{ filter: p.enabled ? "drop-shadow(0 0 4px #00F0FF)" : "grayscale(1) brightness(0.5)" }} />
        </button>
      ))}
    </div>
  );
}

export function TourBench({ wrestlers, selectedId, pops, planes, onOpenPlane, onSelect, onDragStart, onDropToBench, onBenchTap }) {
  const [over, setOver] = useState(false);
  return (
    <div className="relative rounded-xl p-[2px] transition-shadow" onClick={onBenchTap}
         style={{ background: "linear-gradient(90deg, #9D00FF, #00F0FF)", boxShadow: over ? "0 0 22px #FFE60088" : "0 0 18px rgba(0,240,255,0.25)" }}>
      <div data-testid="tour-bench" className="relative rounded-[10px] bg-[#0A051A]/95 pl-28 sm:pl-56 pr-3 py-2 min-h-[164px] sm:h-[164px] overflow-hidden flex flex-col"
           onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
           onDrop={(e) => { e.preventDefault(); setOver(false); const wid = e.dataTransfer.getData("text/wrestler"); if (wid) onDropToBench(wid); }}>
        <img src="/tour/Tour Bus.webp" alt="Tour Bus" draggable={false} data-testid="tour-bus-image"
             className="absolute left-1 sm:left-2 top-1/2 -translate-y-1/2 w-24 sm:w-52 pointer-events-none drop-shadow-[0_0_12px_rgba(157,0,255,0.6)]" />
        <PlaneButtons planes={planes} onOpenPlane={onOpenPlane} />
        <div className="flex items-center gap-2 mb-1.5 pr-10 sm:pr-40">
          <h2 className="font-heading text-base uppercase tracking-widest neon-cyan">Tour Bus</h2>
          <span className="hidden lg:inline font-mono text-[10px] text-[#A89BCC] truncate">Drag onto a venue, or tap a wrestler then a venue. Drag back here to unassign.</span>
        </div>
        {wrestlers.length === 0 ? (
          <div className="flex items-center gap-2 text-xs font-mono text-[#A89BCC] py-3" data-testid="tour-bench-empty">
            <MapPin size={14} className="shrink-0" /> Everyone on tour is booked at a venue. Send more wrestlers via the Tour button on their wrestler page.
          </div>
        ) : (
          <div className="flex flex-wrap sm:flex-nowrap gap-2 overflow-hidden flex-1 min-h-0 items-start" data-testid="tour-bench-list">
            {wrestlers.map((w) => (
              <BenchCard key={w.wrestler_id} w={w} selected={selectedId === w.wrestler_id} pops={pops[w.wrestler_id]} onSelect={onSelect} onDragStart={onDragStart} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
